import React, { useContext } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { UiContext } from 'uiContext';
import { DEFAULT_ELEVATION } from 'assets/theme';
import IconCODD from 'icons/iconCODD';
import RoundedContainer from 'components/baseElements/roundedContainer';
import SpeedContainer from 'components/speedStat/components/speedContainer';
import { getScoreThemeColor, makeTransition } from 'helpers/utils';

export type SpeedStatProps = {
  score: number;
  directSpeed: number;
  reverseSpeed: number;
  timeString: string;
  isOpen?: boolean;
};

export default function SpeedStatDesktop({
  score,
  directSpeed,
  reverseSpeed,
  timeString,
  isOpen = false,
}: SpeedStatProps) {
  const {
    spacings: {
      uiElems: {
        speedStat: { desktop, tablet },
      },
      sp,
    },
  } = useContext(UiContext);
  const theme = useTheme();
  const { isTablet } = useContext(UiContext);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'stretch',
        height: isTablet ? tablet.height : desktop.height,
        opacity: isOpen ? 0 : 1,
        transition: makeTransition(['height', 'opacity']),
      }}
    >
      <RoundedContainer
        roundSide="left"
        sx={{
          bgcolor: getScoreThemeColor(score),
          gap: isTablet ? sp.s15 : sp.s20,
          px: isTablet ? '14px' : sp.s25,
        }}
      >
        <Typography
          sx={{ color: 'custom.scoreDigit' }}
          variant={isTablet ? 'f24' : 'f26'}
        >
          {score}
        </Typography>
        <IconCODD extColor={theme.palette.custom.scoreDigit}></IconCODD>
      </RoundedContainer>

      <RoundedContainer
        roundSide="right"
        sx={{
          justifyContent: 'space-between',
          gap: sp.s70,
          py: sp.s10,
          background:
            // @ts-ignore
            theme.palette.customBackgrounds[
              `elevation${DEFAULT_ELEVATION + 1}`
            ],
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: sp.s5,
          }}
        >
          <Typography variant={isTablet ? 'f8' : 'f10'}>
            Скорость потока
          </Typography>
          <SpeedContainer
            directSpeed={directSpeed}
            reverseSpeed={reverseSpeed}
            isMobileIcons={false}
            isTablet
          ></SpeedContainer>
        </Box>

        <Box>
          <Typography sx={{ color: 'text.secondary' }} variant="f10">
            {timeString}
          </Typography>
        </Box>
      </RoundedContainer>
    </Box>
  );
}
